export const FORCED_CHECKOUT_LEAVE_REASON_CODE = "POINT15";
export const FORCED_CHECKOUT_LEAVE_REASON_TEXT = "扣點達15點(含)以上退宿";

function buildForcedCheckoutLeaveReason() {
	return {
		commCode: FORCED_CHECKOUT_LEAVE_REASON_CODE,
		commValue: FORCED_CHECKOUT_LEAVE_REASON_TEXT,
	};
}

function isForcedCheckoutLeaveReason(commCode) {
	return commCode === FORCED_CHECKOUT_LEAVE_REASON_CODE;
}

export function getVisibleLeaveReasonList(leaveReasonList, options = {}) {
	const list = Array.isArray(leaveReasonList) ? leaveReasonList : [];
	const { fromDeduct, forceGuaranteeOnly, currentLeaveReason } = options;
	const forcedCheckoutLeaveReason = list.find(item => isForcedCheckoutLeaveReason(item.commCode)) || buildForcedCheckoutLeaveReason();

	if (fromDeduct && forceGuaranteeOnly) {
		return [forcedCheckoutLeaveReason];
	}

	const visibleReasonList = list.filter(item => !isForcedCheckoutLeaveReason(item.commCode));
	if (currentLeaveReason === FORCED_CHECKOUT_LEAVE_REASON_CODE) {
		visibleReasonList.push(forcedCheckoutLeaveReason);
	}

	return visibleReasonList;
}

export function resolveLeaveReasonSelection(currentLeaveReason, options = {}) {
	const { fromDeduct, forceGuaranteeOnly } = options;
	if (fromDeduct && forceGuaranteeOnly) {
		return FORCED_CHECKOUT_LEAVE_REASON_CODE;
	}

	return currentLeaveReason || "";
}